import { create } from 'zustand';

const useRefreshStore = create((set, get) => ({
  refreshKey: 0,
  _refreshResolve: null,
  _pendingCount: 0,
  triggerRefresh: () => set((state) => ({ refreshKey: state.refreshKey + 1 })),
  setRefreshResolve: (resolve) => set({ _refreshResolve: resolve, _pendingCount: 0 }),
  registerRefresh: () => set((state) => ({ _pendingCount: state._pendingCount + 1 })),
  completeRefresh: () => {
    const { _refreshResolve, _pendingCount } = get();
    const newCount = Math.max(_pendingCount - 1, 0);
    set({ _pendingCount: newCount });

    // 모든 콜백이 완료되었을 때만 PTR 종료
    if (newCount <= 0 && _refreshResolve) {
      _refreshResolve();
      set({ _refreshResolve: null });
    }
  },
}));

export default useRefreshStore;
